<section class="d-flex overflow-hidden">
  <div class="d-flex w-65 justify-content-between">
    <h2 class="align-self-center">Track Moves</h2>
    <div class="w-75">
      <mat-form-field class="w-75 mt-1">
        <mat-label>Select a Track</mat-label>
        <mat-select #select disableOptionCentering (selectionChange)="emitTrack($event)" [(ngModel)]="selectedFromTrack">
          <mat-select-trigger>
            {{ select.value?.name }}
          </mat-select-trigger>
          <mat-option *ngFor="let track of inventoryTracks; let lastItem = last" [value]="track" class="h-auto line-height">
            <div class="font-weight-bold">{{ track.name }}</div>
            <div class="row m-0">
              <div class="col-3">Loads: <b>{{ track.load }}</b></div>
              <div class="col-3">Empties: <b>{{ track.empty }}</b></div>
              <div class="col-3">Tons: <b>{{ track.tons }}</b></div>
              <div class="col-3">Feet: <b>{{ track.feet }}</b></div>
            </div>
            <mat-divider *ngIf="!lastItem"></mat-divider>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="d-flex flex-grow-1 justify-content-between align-self-center">
    <button mat-icon-button aria-label="Refresh" class="bg-dark" matTooltip="Refresh Tracks" (click)="emitRefresh()">
      <mat-icon>
        <i class="fas fa-sync fa-lg fa-inverse"></i>
      </mat-icon>
    </button>
    <button mat-icon-button class="w-auto px-2" aria-label="Flip"
            [disabled]="!trackConfig.flip"
            (click)="flip()"
            [class.bg-dark]="trackConfig.flip">
      <mat-icon matTooltip="Flip">
        <i class="fas fa-caret-square-up fa-lg fa-inverse"></i>
      </mat-icon>
      <mat-icon matTooltip="Flip" class="ml-n1">
        <i class="fas fa-caret-square-down fa-lg fa-inverse"></i>
      </mat-icon>
    </button>
    <button mat-icon-button aria-label="Up"
            [disabled]="!trackConfig.up"
            (click)="emitAdjust('U')"
            [class.bg-dark]="trackConfig.up">
      <mat-icon matTooltip="Move Up">
        <i class="fas fa-caret-square-up fa-lg fa-inverse"></i>
      </mat-icon>
    </button>
    <button mat-icon-button aria-label="Down"
            [disabled]="!trackConfig.down"
            (click)="emitAdjust('D')"
            [class.bg-dark]="trackConfig.down">
      <mat-icon matTooltip="Move Down">
        <i class="fas fa-caret-square-down fa-lg fa-inverse"></i>
      </mat-icon>
    </button>
    <button mat-flat-button color="accent" aria-label="Move" [disabled]="!trackConfig.move" (click)="emitMove()">
      Move
    </button>
  </div>
</section>
